// helper fn. to give clean text while removing all html tags if present

export const cleanText = (html = "") => {
    if (!html) return "";

    // create a temporary document in memory
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const text = doc.body.textContent || "";
    return text.replace(/\u00a0/g, " ").trim();
};
